<script setup>
const { toLocaleUrl } = useLocaleUrl();

const props = defineProps({
    class: {
        type: String,
        default: () => '',
    },
    // This is a Storyblok Link Object
    to: {
        type: Object,
        default: () => ({}),
    },
});

const href = computed(() => {
    if (props.to.linktype === 'story') {
        // This is an internal link, maybe with an anchor
        const path = toLocaleUrl(props.to.cached_url);
        const hash = props.to.anchor ? `#${props.to.anchor}` : '';
        return hash ? `${path}${hash}` : path;
    } else {
        // External link or other link types
        return props.to.cached_url;
    }
});
</script>

<template>
    <NuxtLink :to="href" :class="props.class" :target="props.to.target">
        <slot></slot>
    </NuxtLink>
</template>
